<template>
  <b-modal id="breakdownReport"
           title="BreakDown Report"
           :ok-only = "true"
           ok-title = "Close"
           :lazy="true"
           >
    <!-- TODO@PONY need fix URL -->
    <iframe :src="url"
            width="100"
            frameborder = "0"
            size="lg"
            class="iframe">

    </iframe>

  </b-modal>

</template>

<script>
  export default {
    components: {
    },
    created () {

    },
    data () {
      return {

      }
    },
    computed: {
      url () {
        return this.$store.getters['config/link']('breakDown') + this.$store.state.order.ListModuleSessionId
      }
    },
    watch: {
    },
    methods: {
    }
  }
</script>

<style scoped lang="scss">
.iframe {
  display: block;
  width: 100%;
  height: 500px;
  border: 0;
}

</style>
<style>
  [aria-labelledby=sendQuote___BV_modal_header_] {
    width: 750px;
  }
</style>



// WEBPACK FOOTER //
// src/components/summary/MbreakdownReport.vue